<div sa-ellipsis [fullText]="value" >
  <!-- [ngClass]="{'na-color': isNotApplicable()}" -->
</div>
